// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z_0MMU{--wcw-dark-color: #131720}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widget-wrapper-wix-studio": `z_0MMU`,
	"widgetWrapperWixStudio": `z_0MMU`
};
export default ___CSS_LOADER_EXPORT___;
